import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap, switchMap, first } from 'rxjs/operators';
import { RefundEligibilityLiteRq } from 'src/app/models/RefundEligibilityLiteRq';
import { RefundReviewRq } from 'src/app/models/RefundReviewRq';
import { RefundEligibilityReason } from 'src/app/models/RefundEligibilityReason';
import { LoyaltyAccessLevel } from 'src/app/models/LoyaltyAccessLevel';
import { LoyaltyMemberInformation } from 'src/app/models/LoyaltyMemberInformation';
import { BASE_URL } from 'src/app/models/Url';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CancelRefundService {

  refundDetailsURL = '/refund/details/';
//   refundDetailsURL = '/selfServiceRefund/refund/details/';
//   refundSubmitURL = '/selfServiceRefund/refund/submit';
//   inEligibilityURL = '/selfServiceRefund/ineligible';
//   goBackURL = '/selfServiceRefund/goback';
//   errorURL = '/selfServiceRefund/error';
//   contactReservationsURL = '/selfServiceRefund/contact/reservations'
//   environmentURL = '/selfServiceRefund/environment';
//   loyaltyAccessLevelURL = '/loyalty/access-level';
//   loyaltyMemberInfoURL = '/loyalty/api/member-information';
  refundSubmitURL = '/refund/submit';
  inEligibilityURL = '/ineligible';
  goBackURL = '/goback';
  errorURL = '/error';
  contactReservationsURL = '/contact/reservations';
  environmentURL = '/environment';
  loyaltyAccessLevelURL = '/loyalty/access-level';
  loyaltyMemberInfoURL = '/loyalty/api/member-information';

  refundEligibilityLiteRq: RefundEligibilityLiteRq;
  refundReviewRq: RefundReviewRq;

  constructor(private http: HttpClient,
              @Inject(BASE_URL) public baseUrl: string, ) {  }

  getRefundReviewRq(): RefundReviewRq {
    return this.refundReviewRq;
  }
  isEligible(refundEligibilityLiteRq: string): Observable<boolean> {
    // return this.retrieveEligibilityDetails(recordLocator)
    return this.retrieveEligibilityDetails(refundEligibilityLiteRq)
        .pipe(tap((res: any) => {
        this.refundReviewRq = res;
        console.log('isEligible.. ' + res);
        console.log('isEligible val reason.. ' + res.eligibilityReason);
        console.log('isEligible Reason.. ' + this.refundReviewRq.eligibilityReason);
        console.log('compared value toString.. ' + RefundEligibilityReason.REFUND_INELIGIBLE);
        }),
        // switchMap(val => of(RefundEligibilityReason.REFUND_INELIGIBLE)));
        switchMap(res => {
          return of(res.eligibilityReason !== RefundEligibilityReason.REFUND_INELIGIBLE)
        }));
  }

  retrieveEligibilityDetails(refundEligibilityLiteRq: string): Observable<RefundReviewRq> {
    // this.refundEligibilityLiteRq= { recordLocator: recordLocator };
    return this
        .http
        .get<RefundReviewRq>(this.baseUrl + this.refundDetailsURL + refundEligibilityLiteRq);
  }

  cancelForRefund(): Observable<string> {
    // this.refundEligibilityLiteRq= { recordLocator: recordLocator };
    return this
        .http
        .post<string>(this.baseUrl + this.refundSubmitURL, this.refundReviewRq, {headers: httpOptions.headers, responseType: 'text' as 'json'});
  }

  ineligible(): Observable<any> {
    return this.http.get(this.baseUrl + this.inEligibilityURL, {responseType: 'text'});
  }

  goBack(): Observable<any> {
    return this.http.get(this.baseUrl + this.goBackURL, {responseType: 'text'});
  }

  error(): Observable<any> {
    return this.http.get(this.baseUrl + this.errorURL, { responseType: 'text' });
  }

  callReservations(): Observable<any> {
    return this.http.get(this.baseUrl + this.contactReservationsURL, {responseType: 'text'});
  }

  environment(): Observable<any> {
    return this.http.get(this.baseUrl + this.environmentURL, { responseType: 'text' });
  }

  loginStatus(hostURL: string): Observable<LoyaltyAccessLevel> {
    return this
        .http
        .get<LoyaltyAccessLevel>('https://' + hostURL + this.loyaltyAccessLevelURL);
  }

  loyaltyMemberInfo(hostURL: string): Observable<LoyaltyMemberInformation> {
    return this
        .http
        .get<LoyaltyMemberInformation>('https://' + hostURL + this.loyaltyMemberInfoURL);
  }

}

